import { FilterTypes as filterType } from '@/constants/FilterTypes';

export const containsOperation = [
  {
    name: filterType.contains,
    value: filterType.contains,
  },
];

export const notContainsOperation = [
  {
    name: filterType.not_contains,
    value: filterType.not_contains,
  },
];

export const selectOperations = [
  ...containsOperation,
  ...notContainsOperation,
  {
    name: filterType.eq,
    value: filterType.eq,
    options: [],
  },
  {
    name: filterType.ne,
    value: filterType.ne,
    options: [],
  },
];
